export default __webpack_public_path__ + "static/media/22.499d984c.png";